import { Validators } from '@angular/forms';
import { INPUT_TYPES_CONFIG } from '../products.config';

export const HOUSE = {
  nickname: 'PRODUCTS.HOUSE.shortname',
  LIST_OF_OBJECTS: ['houseAdditionalBuildings', 'houseWithContents'],
  properties: [
    { name: 'calculatedClientAge', key: 'CLIENT_AGE', group: 'OBJECT_INFO' },
    {
      name: 'productPackage', key: 'PRODUCT_PACKAGE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      isHouseDamagesCheck: true,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.HUS', value: 'STANDARD' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.HOME_EXTENDED', value: 'STANDARD_INC_ROT' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.HUS_MAKS', value: 'SUPER' }
        ]
      }
    },
    { name: 'moistureOrWaterDamage', key: 'MOISURE_OR_WATER_DAMAGE', group: 'INSURANCE_INFO', },
    { name: 'deficienciesOrErrorsOrDamages', key: 'DEFICIENCIES_OR_ERROR_OR_DAMAGES', group: 'INSURANCE_INFO', },
    {
      name: 'deductible', key: 'DEDUCTIBLE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE_HOUSE.3', value: '3000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE_HOUSE.5', value: '5000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE_HOUSE.7', value: '7000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE_HOUSE.10', value: '10000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE_HOUSE.15', value: '15000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE_HOUSE.20', value: '20000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE_HOUSE.25', value: '25000' }
        ]
      }
    },
    {
      name: 'houseSumInsuredType', key: 'SUM_INSURED_TYPE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_SUM_INSURED_TYPE.FULL_VALUE', value: 'FULL_VALUE' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_SUM_INSURED_TYPE.FIRST_RISK', value: 'FIRST_RISK' },
        ]
      }
    },
    { name: 'houseSumInsured', key: 'SUM_INSURED', group: 'INSURANCE_INFO' },
    {
      name: 'houseIsRented', key: 'HOUSE_IS_RENTED', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_IS_RENTED.NO', value: 'Ingen' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_IS_RENTED.LESS_50', value: 'Mindre enn 50% av boligen' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_IS_RENTED.MORE_50', value: 'Mer enn 50% av boligen' },
        ]
      },
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'houseBuildingStandard', key: 'BUILDING_STANDARD', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_STANDARD.NORMAL', value: 'Normal' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_STANDARD.HIGH', value: 'Høy' },
        ]
      }
    },
    {
      name: 'houseMaintenance', key: 'BUILDING_MAINTENANCE', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_MAINTENANCE.NORMAL', value: 'Godt/normalt vedlikeholdt' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_MAINTENANCE.NOTGODD', value: 'Dårlig vedlikeholdt' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_MAINTENANCE.UPGRADE', value: 'Skal oppgraderes betydelig' },
        ]
      }
    },
    {
      name: 'buildingPermanentlyInhabited', key: 'BUILDING_PARMANENTLY_INHABITED', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'propertyFarmNumber', key: 'PROPERTY_FARM_NUMBER', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.STRING,
      validator: ['']
    },
    {
      name: 'propertyUserNumber', key: 'PROPERTY_USER_NUMBER', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.STRING,
      validator: ['']
    },
    {
      name: 'propertyBuildingNumber', key: 'PROPERTY_BUILDING_NUMBER', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.STRING,
      validator: ['']
    },
    {
      name: 'buildingProtected', key: 'BUILDING_PROTECTED', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_PROTECTED.NO', value: 'Nei' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_PROTECTED.YES', value: 'Verneverdig' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_PROTECTED.MUR', value: 'Fredet' },
        ]
      }
    },
    {
      name: 'objectAddress', key: 'OBJECT_ADDRESS', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.STRING,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'objectZipCode', key: 'OBJECT_ZIP_CODE', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.TEL,
      validator: ['', [
        Validators.required,
        Validators.pattern('[0-9]{4}$')
      ]]
    },
    {
      name: 'houseNumberOfBathrooms', key: 'HOUSE_NUMBER_OF_BATHROOMS', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_NUMBER_OF_BATHROOMS.N0_BADS', value: '0' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_NUMBER_OF_BATHROOMS.1_BAD', value: '1' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_NUMBER_OF_BATHROOMS.2_BADS', value: '2' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_NUMBER_OF_BATHROOMS.3_AND_MORE_BADS', value: '3' },
        ]
      }
    },
    {
      name: 'houseBuildingType', key: 'BUILDING_TYPE', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.HOUSE', value: 'HOUSE' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.CHAIN_DETACHED_HOUSE', value: 'CHAIN_DETACHED_HOUSE' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.TERRACED_HOUSE', value: 'TERRACED_HOUSE' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.DUPLEX', value: 'DUPLEX' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.PARTLY_DUPLEX', value: 'PARTLY_DUPLEX' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.ADDITIONAL_BUILDING', value: 'ADDITIONAL_BUILDING' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.CABIN', value: 'CABIN' }
        ]
      }
    },
    {
      name: 'houseBuildingYear', key: 'BUILDING_YEAR', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.DATE,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        dateView: 'multi-years'
      }
    },
    {
      name: 'houseWithContents', key: 'HOUSE_WITH_CONTENTS', group: 'INSURANCE_INFO',
      values: [
        {
          name: 'bicyclesSumInsured',
          key: 'BICYCLES_SUM_INSURED',
          inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
          validator: ['', [
            Validators.required
          ]],
          settings: {
            list: [
              { key: 'PROPERTIES_FORM.SELECT_LIST.BICYCLES_SUM_INSURED.20', value: '20000' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.BICYCLES_SUM_INSURED.30', value: '30000' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.BICYCLES_SUM_INSURED.40', value: '40000' },
            ]
          }
        },
        // {
        //   name: 'contentsCover',
        //   key: 'CONTENTS_COVER',

        //   // TODO: Use, when contentsCover property will be part of calculation logic
        //   inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
        //   validator: ['', [
        //     Validators.required
        //   ]],
        //   settings: {
        //     list: [
        //       { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_SUM_INSURED_TYPE.FULL_VALUE', value: 'FULL_VALUE' },
        //       { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_SUM_INSURED_TYPE.FIRST_RISK', value: 'FIRST_RISK' },
        //     ]
        //   }
        // },
        {
          name: 'productPackage',
          key: 'HOUSE_CONTENT_PRODUCT_PACKAGE',
          inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
          validator: ['', [
            Validators.required
          ]],
          settings: {
            list: [
              { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.INNBO', value: 'STANDARD' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.INNBO_MAKS', value: 'SUPER' }
            ]
          }
        },
        {
          name: 'deductible', key: 'DEDUCTIBLE', group: 'INSURANCE_INFO',
          inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
          validator: ['', [
            Validators.required
          ]],
          settings: {
            list: [
              { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE_HOUSE.3', value: '3000' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE_HOUSE.5', value: '5000' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE_HOUSE.7', value: '7000' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE_HOUSE.10', value: '10000' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE_HOUSE.15', value: '15000' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE_HOUSE.20', value: '20000' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE_HOUSE.25', value: '25000' }
            ]
          }
        },
        {
          name: 'productSumInsured', key: 'HOUSE_CONTENT_SUM_INSURED', group: 'INSURANCE_INFO',
          inputType: INPUT_TYPES_CONFIG.TEL,
          validator: ['', [
            Validators.required
          ]],
        }
      ]
    },
    { name: 'contentMobileCoverType', key: 'CONTENT_MOBILE_COVER_TYPE', group: 'INSURANCE_INFO' },
    { name: 'objectZipArea', key: 'OBJECT_ZIP_AREA', group: 'OBJECT_INFO' },
    {
      name: 'houseSquareMeters', key: 'SQUARE_METERS', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.NUMBER,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'houseBuildingMaterials', key: 'BUILDING_MATERIALS', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_MATERIALS.WOOD', value: 'WOOD' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_MATERIALS.CONCRETE', value: 'CONCRETE' },
        ]
      }
    },
    {
      name: 'buildingUnUsedhouseSquareMeters', key: 'BUILDING_UNUSED_SQM', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.NUMBER,
      validator: ['', [
        Validators.required
      ]],
    },
    {
      name: 'houseAdditionalBuildings', key: 'HOUSE_ADDITIONAL_BUILDINGS', group: 'OBJECT_INFO',
      values: [
        {
          name: 'houseBuildingMaterials',
          key: 'BUILDING_MATERIALS',
          inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
          validator: ['', [
            Validators.required
          ]],
          settings: {
            list: [
              { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_MATERIALS.WOOD', value: 'WOOD' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_MATERIALS.CONCRETE', value: 'CONCRETE' },
            ]
          }
        },
        {
          name: 'houseSumInsuredType',
          key: 'HOUSE_SUM_INSURED_TYPE',
          inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
          validator: ['', [
            Validators.required
          ]],
          settings: {
            list: [
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_SUM_INSURED_TYPE.FULL_VALUE', value: 'FULL_VALUE' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_SUM_INSURED_TYPE.FIRST_RISK', value: 'FIRST_RISK' },
            ]
          }
        },
        {
          name: 'houseNumberOfBathrooms', key: 'HOUSE_NUMBER_OF_BATHROOMS', group: 'OBJECT_INFO',
          inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
          validator: ['', [
            Validators.required
          ]],
          settings: {
            list: [
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_NUMBER_OF_BATHROOMS.N0_BADS', value: '0' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_NUMBER_OF_BATHROOMS.1_BAD', value: '1' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_NUMBER_OF_BATHROOMS.2_BADS', value: '2' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_NUMBER_OF_BATHROOMS.3_AND_MORE_BADS', value: '3' },
            ]
          }
        },
        {
          name: 'houseBuildingType',
          key: 'BUILDING_TYPE',
          inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
          validator: ['', [
            Validators.required
          ]],
          settings: {
            list: [
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.SHED_NOT_ISOLATED_HOUSE_ADD_KLP', value: 'SHED_NOT_ISOLATED' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.GARAGE_ISOLATED', value: 'GARAGE_ISOLATED' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.GARAGE_NOT_ISOLATED', value: 'GARAGE_NOT_ISOLATED' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.CARPORT', value: 'CARPORT' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.OUTBUILDING_WITH_LIVING_AREA',
                 value: 'OUTBUILDING_WITH_LIVING_AREA'},
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.SHED_ISOLATED_HOUSE_ADD_KLP', value: 'SHED_ISOLATED' }
            ]
          }
        },
        {
          name: 'houseSquareMeters',
          key: 'SQUARE_METERS',
          inputType: INPUT_TYPES_CONFIG.NUMBER,
          validator: ['', [
            Validators.required
          ]],
          settings: {
            maxSquareMeters: (value: number): boolean => value > 200
          }
        },
        {
          name: 'houseAdditionalBuildingBuiltYear',
          key: 'HOUSE_ADDITIONAL_BUILDING_BUILT_YEAR',
          inputType: INPUT_TYPES_CONFIG.DATE,
          validator: ['', [
            Validators.required
          ]],
          settings: {
            dateView: 'multi-years'
          }
        },
        {
          name: 'houseAdditionalBuildingProductPackage',
          key: 'HOUSE_ADDITIONAL_BUILDING_PRODUCT_PACKAGE'
        },
        {
          name: 'houseSMNoCella', key: 'HOUSE_SM_NO_CELLA', group: 'OBJECT_INFO',
          inputType: INPUT_TYPES_CONFIG.BOOLEAN,
          validator: ['', [
            Validators.required
          ]]
        },
        {
          name: 'houseSMFlatRoof', key: 'HOUSE_SM_FLAT_ROOF', group: 'OBJECT_INFO',
          inputType: INPUT_TYPES_CONFIG.BOOLEAN,
          validator: ['', [
            Validators.required
          ]]
        },
        {
          name: 'buildingPermanentlyInhabited', key: 'BUILDING_PARMANENTLY_INHABITED', group: 'INSURANCE_INFO',
          inputType: INPUT_TYPES_CONFIG.BOOLEAN,
          validator: ['', [
            Validators.required
          ]]
        },
        {
          name: 'propertyBuildingNumber', key: 'PROPERTY_BUILDING_NUMBER', group: 'INSURANCE_INFO',
          inputType: INPUT_TYPES_CONFIG.STRING,
          validator: ['']
        },
      ]
    },
    {
      name: 'houseSMAlarmBurglar', key: 'HOUSE_SM_ALARM_BURGAR', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'houseSMElectricalControl', key: 'HOUSE_SM_ELECTRICAL_CONTROL', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    { name: 'houseSMPipeInPipe', key: 'HOUSE_SM_PIPE_IN_PIPE', group: 'OBJECT_INFO' },
    { name: 'houseRotAndAnimalDamage', key: 'HOUSE_ROT_AND_ANIMAL_DAMAGE', group: 'INSURANCE_INFO' },
    {
      name: 'houseSMFireAlarmConnected', key: 'HOUSE_SM_FIRE_ALARM_CONNECTED_KLP', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'houseSMNoCella', key: 'HOUSE_SM_NO_CELLA', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'houseSMFlatRoof', key: 'HOUSE_SM_FLAT_ROOF', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'houseSMBurglarAlarmConnected', key: 'HOUSE_SM_BURGAR_ALARM_CONNECTED_KLP', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'houseSMAutomaticWaterStop', key: 'HOUSE_SM_AUTOMATIC_WATER_STOP', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    { name: 'houseSMAutomaticCircuitBreaker', key: 'HOUSE_SM_AUTOMATIC_CIRCUIT_BREAKER', group: 'OBJECT_INFO' },
    { name: 'houseSurgeProtectionInFuseCabinet', key: 'HOUSE_SURGE_PROTECTION_IN_FUSE_CABINET', group: 'OBJECT_INFO' }
  ],
  icon: 'house'
};
